import { FormattedText, ImageComponent, LandingButton } from "@tm/static";
import React from "react";

import { ModalWrapper } from "../../../../components/ModalWrapper/ModalWrapper";
import { ORDER_DETAIL_V2_ASSETS } from "../../constants";
import type { OrderDetailV2ActionModalProps } from "../../types";

import {
  ActionModalBody,
  ActionModalMessage,
  ActionModalTitle,
} from "./OrderDetailV2ActionModal.style";

export const OrderDetailV2ActionModal: React.FC<
  OrderDetailV2ActionModalProps
> = ({ config, onClose }) => {
  if (!config) return null;
  return (
    <ModalWrapper
      isOpen={Boolean(config)}
      onClose={onClose}
      customWidth="420px"
    >
      <ActionModalBody>
        {config.iconType === "success" && (
          <ImageComponent
            src={ORDER_DETAIL_V2_ASSETS.SUCCESS_ICON}
            width="56"
            height="56"
            alt="Success"
            margin="0 auto 20px"
          />
        )}
        <ActionModalTitle>
          <FormattedText value={config.title} />
        </ActionModalTitle>
        <ActionModalMessage>
          <FormattedText value={config.message} />
        </ActionModalMessage>
        {config.primaryCta && (
          <LandingButton
            customTitle={config.primaryCta.label}
            onClick={onClose}
            customWidth="100%"
          />
        )}
      </ActionModalBody>
    </ModalWrapper>
  );
};

export default OrderDetailV2ActionModal;
